import { importLibrary, setOptions } from "@googlemaps/js-api-loader";

let placesPromise;
let configured = false;

export const withPlacesTimeout = promise => {
  let timer;
  return Promise.race([promise, new Promise((_, reject) => {
    timer = window.setTimeout(() => reject(new Error("Address lookup timed out")), 8000);
  })]).finally(() => window.clearTimeout(timer));
};

export const loadGooglePlaces = () => {
  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!key) return Promise.reject(new Error("Address suggestions are not configured"));
  if (!configured) {
    setOptions({ key, v: "weekly", language: "en", region: "US" });
    configured = true;
  }
  if (!placesPromise) {
    placesPromise = importLibrary("places").catch(error => {
      placesPromise = undefined;
      throw error;
    });
  }
  return withPlacesTimeout(placesPromise);
};

export const mapGoogleAddress = components => {
  const part = (type, short = false) => {
    const value = components?.find(component => component.types.includes(type));
    return (short ? value?.shortText : value?.longText) || "";
  };
  return {
    address1: [part("street_number"), part("route")].filter(Boolean).join(" ") || part("premise"),
    address2: part("subpremise"),
    city: part("locality") || part("postal_town") || part("sublocality_level_1") || part("sublocality"),
    region: part("administrative_area_level_1", true),
    postal_code: [part("postal_code"), part("postal_code_suffix")].filter(Boolean).join("-"),
    country: part("country", true),
  };
};